module.exports = __webpack_public_path__ + "img/product-19.4ac46825.jpg";